// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@ces/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { TextFieldProps } from "@ces/MobiusOverrides/TextField/TextField";
import translate from "@insite/client-framework/Translate";
import { poNumberStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldPoNumber";

poNumberStyles.textField = {
    placeholder: translate("Purchase Order #"),
    label: translate("Purchase Order #"),
} as TextFieldProps;

poNumberStyles.wrapper = {
    wrapper: {
        ...myAccountFilterSectionStyles.searchFieldWrapper,
    },
};
